export const chromeDownloadLink = 'https://www.google.com/chrome/';
